module.exports = __webpack_public_path__ + "img/auto.8ba3a1f5.svg";